'use strict';

var UserManagerService = function (jsonrpc) {
    var service = jsonrpc.newService('users_manager');
    this.roles = service.createMethod('roles');
    this.users = service.createMethod('users');
    this.get_user = service.createMethod('get_user');
    this.create_user = service.createMethod('create_user');
    this.delete_user = service.createMethod('delete_user');
    this.toggle_admin_user = service.createMethod('toggle_admin_user');
    this.toggle_activate_user = service.createMethod('toggle_activate_user');
    this.user_set_password = service.createMethod('user_set_password');
    this.user_add_role_or_action = service.createMethod('user_add_role_or_action');
    this.user_remove_role_or_action = service.createMethod('user_remove_role_or_action');
};

UserManagerService.$inject = ['jsonrpc'];


Array.prototype.remove = function() {
    var what, a = arguments, L = a.length, ax;
    while (L && this.length) {
        what = a[--L];
        while ((ax = this.indexOf(what)) !== -1) {
            this.splice(ax, 1);
        }
    }
    return this;
};


var UserProfileCtrl = function ($scope, $state, current_user, user, role_items, UserManagerService, Restangular, $uibModalInstance) {
    $scope.current_user = current_user;
    $scope.user = user;
    $scope.data = Restangular.stripRestangular(role_items);
    $scope.toggle_role_or_action = function (role_or_action) {
        var meth = $scope.user.permissions[role_or_action]
            ? UserManagerService.user_remove_role_or_action
            : UserManagerService.user_add_role_or_action;
        var res = meth({'email': $scope.user.id, role_or_action: role_or_action});

        res.then(function(user){
            $scope.user = user
        });
    };
};

UserProfileCtrl.$inject = ['$scope', '$state', 'currentUser', 'user', 'role_items', 'UserManagerService',
    'Restangular', '$uibModalInstance'];

var UserProfileCtrlTpl = require('./user_roles.html');

var UserMangerCtrl = function ($scope, $state, currentUser, user_items, $uibModal, UserManagerService, FormModalFactory) {
        $scope.current_user = currentUser;
        $scope.user_items = user_items;
        $scope.isNotCurrentUser = function (user) {
            return $scope.current_user.data.id !== user.id
        };
        $scope.isNotAdminRole = function (role) {
            return role !== 'admin'
        };
        $scope.hasAdminRole = function (user) {
            return user.roles.indexOf('admin') > -1
        };
        $scope.toggle_admin_confirmed = function (user_id) {
            var user = _.find($scope.user_items, function (obj) {
                return obj.id === user_id
            });
            user.admin_confirmed = !user.admin_confirmed;
            user.put()
        };

        $scope.create_user = function () {
            FormModalFactory
                .open('users_manager.CreateUserForm')
                .then(function(new_user){
                    $scope.user_items[new_user.email] = new_user
                })
        };

        $scope.delete_user = function (user_id) {
            var user = _.find($scope.user_items, function (obj) {
                return obj.id === user_id
            });
            if (!confirm('Delete user : ' + user.email + ' ?')) {
                return
            }
            UserManagerService
                .delete_user({'email': user.id})
                .then(function(removed_user){
                    delete $scope.user_items[removed_user.email]
                });
        };
        $scope.toggle_admin_user = function (user_id) {
            var user = _.find($scope.user_items, function (obj) {
                return obj.id === user_id
            });
            UserManagerService
                .toggle_admin_user({'email': user.id})
                .then(function(user){
                    $scope.user_items[user_id] = user
                });
        };

        $scope.toggle_activate_user = function (user_id) {
            var user = _.find($scope.user_items, function (obj) {
                return obj.id === user_id
            });
            UserManagerService
                .toggle_activate_user({'email': user.id})
                .then(function(user){
                    $scope.user_items[user_id] = user
                });
        };

        $scope.open_modal_form = function (form_name, user_id) {
            FormModalFactory
                .open(form_name,
                    {'email': user_id}
                )
                .then(function (user) {
                    $scope.user_items[user.email] = user
                });
        };

    }
    ;

UserMangerCtrl.$inject = ['$scope', '$state', 'currentUser', 'user_items', '$uibModal', 'UserManagerService', 'FormModalFactory'];

var UserMangerCtrlTpl = require('./user_manager.html');

export default function (app) {
    app.service('UserManagerService', UserManagerService);
    app.controller('UserProfileCtrl', UserProfileCtrl);
    app.controller('UserMangerCtrl', UserMangerCtrl);

    app.run(['$templateCache', function ($templateCache) {
        $templateCache.put('amt_admin/user_manager/list.html', UserMangerCtrlTpl);
    }]);

    app.run(['$templateCache', function ($templateCache) {
        $templateCache.put('amt_admin/user_manager/roles.html', UserProfileCtrlTpl);
    }]);

    app.config(['$stateProvider', function ($stateProvider) {
        $stateProvider
            .state('user_manager', {
                parent: 'amt',
                url: '/user_manager',
                template: '<div ui-view=""></div>',
                abstract: true,
                data: {
                    title: "User Manager",
                    role: "admin",
                    priority: 900
                },
                menu: {
                    position: 'top',
                    fa_icon: "users",
                    childs: [
                        {state: 'user_manager.list'}
                    ]
                }
            })
            .state('user_manager.list', {
                url: '/list',
                templateUrl: 'amt_admin/user_manager/list.html',
                controller: 'UserMangerCtrl',
                resolve: {
                    user_items: ['UserManagerService', function (UserManagerService) {
                        return UserManagerService.users();
                    }]
                },
                data: {
                    title: "User Manager"
                }
            })
            .state("user_manager.profile", {
                url: '/:user_id',
                template: UserProfileCtrlTpl,
                controller: 'UserProfileCtrl',
                data: {
                    title: "Edit Profile"
                },
                resolve: {
                    user: ['UserManagerService', '$stateParams', function (UserManagerService, $stateParams) {
                        return UserManagerService.get_user({'email': $stateParams.user_id});
                    }],
                    role_items: ['UserManagerService', function (UserManagerService) {
                        return UserManagerService.roles();
                    }]
                }
            });

    }])
};
